import {OrderedSet} from 'immutable';

export const ADMINISTRATOR = 'administrator';
export const TEACHER = 'teacher';
export const PROFESSIONAL_SUPPORT_STAFF = 'professional_support_staff';
export const SUPPORT_STAFF = 'support_staff';
export const OFFICE_STAFF = 'office_staff';
export const ESA_TRAINER = 'esa_trainer';
export const OTHER = 'other';
export const PARENT_COMMUNITY_MEMBER = 'parent_community_member';
export const ALL = new OrderedSet([
  ADMINISTRATOR,
  TEACHER,
  PROFESSIONAL_SUPPORT_STAFF,
  SUPPORT_STAFF,
  OFFICE_STAFF,
  ESA_TRAINER,
  OTHER,
  PARENT_COMMUNITY_MEMBER
]);


// WEBPACK FOOTER //
// ./app/features/authentication/constants/titles.js